import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_page_settings_user from '@/locales/keys/i18n_page_settings_user.json';
import { InputWithButtonEdit } from '@/pages/_base/inputs/InputWithButtonEdit';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { remote_workspace_update } from '@/state/workspace/entity/remote_workspace_update';
import { FC, memo, useState } from 'react';
import { useTranslation } from 'react-i18next';

const InputWorkspaceName: FC = memo(() => {
  const dispatch = use_dispatch();

  const { workspace_current } = use_slice_workspace(['workspace_current']);

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_USER);

  const [value, set_value] = useState(workspace_current.name);

  /*
   * EVENTS
   */

  async function onInputChangeCommited(value_new: string) {
    const value_new_update = value_new.is_blank() ? workspace_current.name : value_new;
    onInputChange(value_new_update);

    if (value_new_update == workspace_current.name) return;

    const workspace_new = workspace_current.clone({ name: value_new_update });

    await dispatch(remote_workspace_update(workspace_new));
  }

  function onInputChange(value: string) {
    set_value(value);
  }

  /*
   * EFFECTS
   */

  /*
   * METHODS
   */

  return (
    <div className="flex gap-3 items-center">
      <h3 className="flex w-[10rem]">{t(i18n_page_settings_user.tabs.account.general_component.input.user_name.label)}:</h3>

      <InputWithButtonEdit
        onChange={onInputChange}
        value={value}
        value_default={workspace_current.name}
        onChangeCommited={onInputChangeCommited}
        className="min-h-9 max-h-9 h-9"
      />
    </div>
  );
});

export default InputWorkspaceName;
